<template>
  <div class="container-custom" :style="styleObject">
    <div class="content-custom" v-on:scroll.passive="handleScroll($event)">
      <!-- Dining option + member live in the header only; the dining pill
           opens the picker, which lists whichever options the branch offers. -->
      <Header :dining-switchable="canChangeDining" @change-dining="openDiningOption"></Header>
      <div class="order-info">
        <div class="category-list">
          <div
            v-for="(category, index) in categories"
            :key="index"
            class="category-tag"
            v-bind="kskSlot('category_tab')"
            :id="'category-tag-' + category.id"
            :class="[
              { active: categorySelect.id == category.id },
              'tag-name-category-' + category.id,
            ]"
            @click="selectCategory(category, index)"
          >
            <div class="wrap-category">
              <img class="c-img" :src="category.img_version" alt="" />
              <!-- KSK064: merchant-chosen icon replaces the featured star. -->
              <span v-if="isKioskIcon(category.kiosk_icon)" class="custom-star">
                <KskIcon :name="category.kiosk_icon" />
              </span>
              <span
                v-else-if="category.is_feature"
                class="custom-star material-icons-round"
                aria-label="Featured"
              >star</span>
            </div>
            <div class="c-name">
              {{ tName(category.second_name) }}
            </div>
          </div>
        </div>
        <div class="content" v-if="isLoadDone">
          <div id="show" class="position-fixed fly-cart">
            <img class="img-fluid" src="" alt="" />
          </div>
          <div class="category-detail" v-if="categorySelect">
            <div>
              <!-- KSK008 category title + item count -->
              <div class="ksk-category-head">
                <h2 class="ksk-category-head__title">{{ tName(categorySelect.second_name) }}</h2>
                <span class="ksk-category-head__count">
                  {{ $t(categoryItemCount(categorySelect) === 1 ? "kiosk.common.itemOne" : "kiosk.common.itemMany", { count: categoryItemCount(categorySelect) }) }}
                </span>
              </div>
              <div class="item-list">
                <div class="ksk-item-grid">
                  <KskItemCard
                    v-for="(item, index2) in categorySelect.items"
                    :key="index2"
                    :item="item"
                    :animClass="'item-img-' + categorySelect.id + '-' + item.id"
                    :quantity="getTotalQuantityById(item.id)"
                    :available="checkAvailableItem(item)"
                    :isLogined="isLogined"
                    :hasMemberDiscount="hasMemberDiscount(item)"
                    :priceText="formatItemPrice(item)"
                    :memberPriceText="formatItemPrice(item, true)"
                    :weightPriceText="formatWeightPrice(item)"
                    :strikePriceText="formatStrikePrice(item)"
                    @open="gotoOrderDetail(categorySelect.id, item.id, item.stock_balance, item.is_not_available, item.stock_enable_balance, item)"
                    @add="openBoxChangeQuantityForItemWithoutModifier(categoryIndexSelect, index2, item, categorySelect.id)"
                    @change-quantity="(type) => handleQuantityForMainItem(item, type, categorySelect.id, categoryIndexSelect, index2)"
                  />
                </div>
              </div>
            </div>
            <div v-if="categorySelect.groups && categorySelect.groups.length">
              <div
                class="item-list"
                v-for="(group, index3) in categorySelect.groups"
                :key="index3"
              >
                <div>
                  <div
                    class="tag-name-group"
                    :class="'tag-name-group-' + group.id"
                  >
                    {{ tName(group.name) }}
                  </div>
                  <div class="grid border-0">
                    <div class="ksk-item-grid">
                      <KskItemCard
                        v-for="(item, index5) in group.items"
                        :key="index5"
                        :item="item"
                        :animClass="'item-img-' + categorySelect.id + '-' + group.id + '-' + item.id"
                        :quantity="getTotalQuantityById(item.id)"
                        :available="checkAvailableItem(item)"
                        :isLogined="isLogined"
                        :hasMemberDiscount="hasMemberDiscount(item)"
                        :priceText="formatItemPrice(item)"
                        :memberPriceText="formatItemPrice(item, true)"
                        :weightPriceText="formatWeightPrice(item)"
                        :strikePriceText="formatStrikePrice(item)"
                        @open="gotoOrderDetail(categorySelect.id, item.id, item.stock_balance, item.is_not_available, item.stock_enable_balance, item)"
                        @add="groupOpenBoxChangeQuantityForItemWithoutModifier(index3, index5, categoryIndexSelect, item, group.id)"
                        @change-quantity="(type) => groupHandleQuantityForMainItem(item, type, group.id, index3, index5, categoryIndexSelect)"
                      />
                    </div>
                  </div>
                </div>
                <div v-if="group.sub_groups && group.sub_groups.length">
                  <div
                    class="item-list"
                    v-for="(subGroup, index6) in group.sub_groups"
                    :key="index6"
                  >
                    <div>
                      <div class="tag-name-sub-group">
                        {{ tName(subGroup.name) }}
                      </div>
                      <div class="grid border-0">
                        <div class="ksk-item-grid">
                          <KskItemCard
                            v-for="(item, index8) in subGroup.sub_group_items"
                            :key="index8"
                            :item="item"
                            :animClass="'item-img-' + categorySelect.id + '-' + group.id + '-' + subGroup.id + '-' + item.id"
                            :quantity="getTotalQuantityById(item.id)"
                            :available="checkAvailableItem(item)"
                            :isLogined="isLogined"
                            :hasMemberDiscount="hasMemberDiscount(item)"
                            :priceText="formatItemPrice(item)"
                            :memberPriceText="formatItemPrice(item, true)"
                            :weightPriceText="formatWeightPrice(item)"
                            :strikePriceText="formatStrikePrice(item)"
                            @open="gotoOrderDetail(categorySelect.id, item.id, item.stock_balance, item.is_not_available, item.stock_enable_balance, item)"
                            @add="subGroupOpenBoxChangeQuantityForItemWithoutModifier(index3, index8, categoryIndexSelect, index6, item, subGroup.id)"
                            @change-quantity="(type) => subGroupHandleQuantityForMainItem(item, type, subGroup.id, index3, index8, categoryIndexSelect, index6)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer
        :confirmStartOver="confirmStartOver"
        @logoutDone="logoutDone"
      ></Footer>

      <div
        class="position-fixed top-1 end-1 message-success"
        style="z-index: 99999 !important"
      >
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
    </div>
    <ModalSignInNew></ModalSignInNew>
    <material-loading :active="loaderActive" />
    <material-loading-without-animation
      :active="loaderActiveWithoutAnimation"
    />
    <ModalItemDetail
      :categoryId="categoryIdSelect"
      :itemId="itemIdSelect"
      :itemDetail="itemDetail"
      :isLogined="isLogined"
      :reloadModal="reloadModal"
      :loading="itemDetailLoading"
      @clear-data-item="clearDataItem"
      @show-error="showKioskError"
    />
    <ModalWeighing
      :itemDetail="weighingItemDetail"
      :reloadModal="reloadWeighingModal"
      @weighing-complete="onWeighingComplete"
      @weighing-blocked="showKioskError"
    />
    <ModalSelectDiningOption
      :diningLocation="dining_location"
      :selectDiningOption="selectDiningOption"
      :selected="diningOption ? Number(diningOption) : null"
      :dismissible="!!diningOption"
    />
    <ModalDiningItemsRemoved
      :items="removedDiningItems"
      :dining-option="removedDiningOption"
    />
    <ModalConfirm
      :message="txtConfirm"
      :ksk-preset="kskConfirmPreset"
      :process-yes="processYes"
      :isKiosk="true"
    />
    <ModalConfirmStillThere
      :keyReload="keyReload"
      :continueMyOrder="continueMyOrder"
      :resetNow="resetNow"
    />
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from "vue";
import SwiperCore, { Pagination, Autoplay } from "swiper";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import Header from "../kiosk/components/Header.vue";
import OrderService from "../../services/order.service";
import $ from "jquery";
import "bootstrap/dist/js/bootstrap.bundle";
import Footer from "../kiosk/components/OrderFooter.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import ModalItemDetail from "../kiosk/components/ModalItemDetail.vue";
import ModalWeighing from "../kiosk/components/ModalWeighing.vue";
import EventBus from "vue3-eventbus";
import MaterialLoadingWithoutAnimation from "@/components/MaterialLoadingWithoutAnimation.vue";
import { TweenMax } from "gsap";
import { localStorageName, getDiningOption, getCartItemIndexesInvalidForDiningOption } from "@/config/utils";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import ModalSelectDiningOption from "../kiosk/components/ModalSelectDiningOption.vue";
import ModalConfirm from "@/components/ModalConfirm.vue";
import ModalDiningItemsRemoved from "../kiosk/components/ModalDiningItemsRemoved.vue";
import ModalConfirmStillThere from "../kiosk/components/ModalConfirmStillThere.vue";
import ModalSignInNew from "../kiosk/components/ModalSignInNew.vue";
import KskItemCard from "../kiosk/components/KskItemCard.vue";
import KskIcon from "../kiosk/components/ui/KskIcon.vue";
import { isKioskIcon } from "@/config/kioskIcons";
import memberService from "../../services/member.service";
import { kskSlot } from "@/config/kioskColorSlots";
import { isKioskPreview } from "@/views/kiosk/kioskPreview";
import { scheduleOriginalPrice } from "@/config/specialPrice";
import {
  collectItemNames,
  loadMenuTranslations,
  prefetchMenuTranslations,
  translatedName,
} from "@/i18n/menuTranslate";

SwiperCore.use([Pagination, Autoplay]);

export default {
  name: "Order",
  components: {
    Header,
    Footer,
    KskIcon,
    MaterialLoading,
    ModalItemDetail,
    ModalWeighing,
    MaterialLoadingWithoutAnimation,
    MaterialSnackbar,
    ModalSelectDiningOption,
    ModalConfirm,
    ModalDiningItemsRemoved,
    ModalConfirmStillThere,
    ModalSignInNew,
    KskItemCard,
  },
  data() {
    return {
      snackbar: null,
      message: "",
      isLoadDone: false,
      loaderActive: false,
      merchantCode: "",
      memberInfo: JSON.parse(
        localStorage.getItem(localStorageName("KIOSK_MEMBER_INFO"), "")
      ),
      branchCode: "",
      branch: JSON.parse(
        localStorage.getItem(localStorageName("BRANCH_INFO"), "")
      ),
      pathType: "",
      categories: [],
      categoryIdSelect: this.$route.params.category_id ?? 0,
      categorySelect: {},
      categoryIndexSelect: 1,
      groupSelect: null,
      typeList: 1,
      itemSearch: [],
      itemIdSelect: 0,
      itemDetail: {},
      itemDetailLoading: false,
      itemDetailRequestId: 0,
      itemSheetOpening: false,
      itemSheetHidePending: false,
      reloadModal: "reload-item-detail",
      weighingItemDetail: {},
      reloadWeighingModal: "reload-weighing-modal",
      isLogined: false,
      cartName: "ORDER_INFO",
      isLoadingGetItemDetail: false,
      loaderActiveWithoutAnimation: false,
      takeAwayOrDineIn: 2, // 1 = take away | 2 = dine in
      showDiningOption: false,
      dining_location: 0,
      diningOption: localStorage.getItem(localStorageName("DINING_OPTION")),
      isIdle: false,
      idleTime: 0,
      idleInterval: null,
      lastActivity: Date.now(),
      keyReload: "keyReload",
      txtConfirm: "",
      kskConfirmPreset: "",
      confirmType: 0,
      removedDiningItems: [],
      removedDiningOption: 1,
    };
  },
  setup() {
    const isOnline = ref(navigator.onLine);

    const updateOnlineStatus = () => {
      isOnline.value = navigator.onLine;
    };

    onMounted(() => {
      window.addEventListener("online", updateOnlineStatus);
      window.addEventListener("offline", updateOnlineStatus);
    });

    onUnmounted(() => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
    });

    return {
      isOnline,
    };
  },
  async created() {
    this.merchantCode = this.$store.state.merchantCode;
    this.branchCode = this.$store.state.branchCode;
    this.cartName = await this.$store.dispatch("cartName");

    if (this.memberInfo) {
      this.isLogined = true;
    }
  },
  async mounted() {
    $(".modal-backdrop.fade.show").remove();

    const memorize = this.$route.params.memorize ?? null;
    if (memorize) {
      $(".bottom_modal_memorize").click();
    }

    if (this.merchantCode && this.branchCode) {
      await this.getListCategory(1, true);
    }

    // KSK051: named so beforeUnmount can remove them; a listener left behind
    // keeps firing on the next page (e.g. Logout on Checkout ran this page's
    // confirmLogout as well).
    this.busHandlers = {
      AddToCartThenReloadCategorySuccess: (e) => {
        setTimeout(() => {
          if (e.time == this.reloadModal) {
            this.getListCategory(2, false);
          }
        }, 300);
      },
      Logout: () => {
        this.confirmLogout();
      },
      LoginSuccess: () => {
        this.memberInfo = JSON.parse(
          localStorage.getItem(localStorageName("KIOSK_MEMBER_INFO")) || "null"
        );
        this.isLogined = !!this.memberInfo;
      },
    };
    Object.entries(this.busHandlers).forEach(([event, handler]) => EventBus.on(event, handler));

    window.onpopstate = (e) => {
      if (this.itemIdSelect) {
        e.preventDefault();
        history.go(1);
      }
    };

    document
      .querySelector(".main-content")
      .addEventListener("mousemove", this.resetIdleTimer);
    document
      .querySelector(".main-content")
      .addEventListener("keypress", this.resetIdleTimer);
    document
      .querySelector(".main-content")
      .addEventListener("click", this.resetIdleTimer);
    document
      .querySelector(".main-content")
      .addEventListener("scroll", this.resetIdleTimer);

    this.startIdleTimer();
  },
  beforeUnmount() {
    Object.entries(this.busHandlers || {}).forEach(([event, handler]) => EventBus.off(event, handler));
    document
      .querySelector(".main-content")
      .removeEventListener("mousemove", this.resetIdleTimer);
    document
      .querySelector(".main-content")
      .removeEventListener("keypress", this.resetIdleTimer);
    document
      .querySelector(".main-content")
      .removeEventListener("click", this.resetIdleTimer);
    document
      .querySelector(".main-content")
      .removeEventListener("scroll", this.resetIdleTimer);
    clearInterval(this.idleInterval);
    this.idleInterval = null;

    this.closeAllModal();
  },
  watch: {
    // KSK096: language switched from the header — re-translate the menu.
    "$i18n.locale"() {
      this.syncMenuNames();
    },
  },
  computed: {
    // The header's dining pill reopens the picker whenever the branch asks
    // for a dining option; the picker shows only the options it offers
    // (dining_location 0 = both, 1 = takeaway, 2 = dine in).
    canChangeDining() {
      return !!this.showDiningOption;
    },
    styleObject() {
      return {
        "--color": this.$store.state.color,
      };
    },
  },
  methods: {
    kskSlot,
    isKioskIcon,
    openDiningOption() {
      if (!this.canChangeDining) return;
      $(".btn-show-modal-select-dining-option").click();
    },

    logoutDone() {
      this.memberInfo = null;
      this.isLogined = false;

      this.snackbar = "success";
      this.message = this.$t("kiosk.common.logoutSuccess");

      this.setTimeOutNotification();
    },

    resetIdleTimer() {
      // Reset thời gian khi có hoạt động
      this.lastActivity = Date.now();
      this.idleTime = 0;
      this.isIdle = false;
      clearInterval(this.idleInterval);
      this.idleInterval = null;
      this.startIdleTimer();
    },

    startIdleTimer() {
      // KSK063: no "still there?" countdown inside Minty's preview.
      if (isKioskPreview()) return;
      this.idleInterval = setInterval(() => {
        const currentTime = Date.now();
        const timeDiff = (currentTime - this.lastActivity) / 1000;
        this.idleTime = Math.floor(timeDiff);

        if (timeDiff >= 60) {
          this.keyReload = Math.random();
          $(".btn-show-modal-confirm-still-there").click();

          this.isIdle = true;
          this.idleTime = 0;
          clearInterval(this.idleInterval);
          this.idleInterval = null;
        }
      }, 1000);
    },

    continueMyOrder() {
      $(".btn-hide-modal-confirm-still-there").click();
      this.resetIdleTimer();
    },

    resetNow() {
      this.closeAllModal();
      localStorage.removeItem(this.cartName);
      localStorage.removeItem(localStorageName("DINING_OPTION"));
      localStorage.removeItem(localStorageName("KIOSK_PROMO_CODE_APPLIED"));
      this.logout();
      this.gotoPath("LandingPageKiosk");
    },

    closeAllModal() {
      $(".btn-close-modal-confirm").click();
      $(".btn-hide-modal-select-dining-option").click();
      $(".btn-hide-modal-signin").click();
      $(".btn-hide-item-detail-modal").click();
      $(".btn-hide-weighing-modal").click();
      $(".btn-hide-modal-item-modifier-option").click();
      $(".btn-hide-modal-confirm-still-there").click();
      $(".btn-hide-modal-dining-items-removed").click();
    },

    formatPrice(price) {
      return "$ " + parseFloat(price).toFixed(2);
    },

    // A Choice item is priced at its first choice and a Sub Category at its cheapest item - the
    // ones Item Detail opens on - which the API already puts on price_default / member_price.
    formatItemPrice(item, isMember = false) {
      return this.formatPrice(isMember ? item.member_price : item.price_default);
    },

    // KSK064: the merchant's strike-off price, only when it is above the
    // price the card shows (base / "from" price).
    // KSK119: during a Special Scheduled Price, the usual price instead.
    formatStrikePrice(item) {
      const strike = scheduleOriginalPrice(item, this.isLogined) || parseFloat(item.strike_price);
      const price = parseFloat(item.price_default);
      return strike > (price || 0) ? this.formatPrice(strike) : "";
    },

    // KSK008: by-weight items are priced per kg; the card shows it per 100g.
    formatWeightPrice(item) {
      const perKg = parseFloat(item.price_per_kg);
      return perKg > 0 ? this.formatPrice(perKg / 10) : "";
    },

    categoryItemCount(category) {
      let count = (category.items || []).length;
      for (const group of category.groups || []) {
        count += (group.items || []).length;
        for (const subGroup of group.sub_groups || []) {
          count += (subGroup.sub_group_items || []).length;
        }
      }
      return count;
    },

    hasMemberDiscount(item) {
      return item.member_price != item.price_default;
    },

    clearDataItem() {
      // KSK063: closing the sheet while it still loads drops that response.
      this.itemDetailRequestId++;
      this.itemDetailLoading = false;
      this.itemIdSelect = 0;
      this.itemDetail = {};
      this.weighingItemDetail = {};
    },

    onWeighingComplete(payload) {
      // payload: { weight_kg, price_per_kg, line_total, unit }
      // Patch itemDetail so ModalItemDetail uses (weight × price_per_kg) as the base price.
      // Modifiers add on top of this (flat, per user spec).
      const base = parseFloat(payload.line_total) || 0;
      const patched = {
        ...this.itemDetail,
        price: base,
        price_default: base,
        member_price: base,
        price_default_no_modifier_option: base,
        member_price_no_modifier_option: base,
        // Audit fields — carried through to cart / order create
        weight_kg: payload.weight_kg,
        price_per_kg: payload.price_per_kg,
        weight_unit: payload.unit,
        weight_line_total: base,
      };
      this.itemDetail = patched;
      this.reloadModal = Math.random(32).toString();
      $(".btn-hide-weighing-modal").click();
      $(".btn-show-item-detail-modal").click();
    },

    selectDiningOption(value) {
      const isSwitch = !!this.diningOption && this.diningOption != value;
      this.takeAwayOrDineIn = value;
      // KSK055: wait for the picker to close before opening the removed-items popup.
      // Bootstrap 5 fires native events, so jQuery .one() would never see it.
      if (isSwitch) {
        const modal = document.getElementById("modalSelectDiningOption");
        if (modal) {
          modal.addEventListener("hidden.bs.modal", () => this.removeItemsInvalidForDining(value), { once: true });
        }
      }
      $(".btn-hide-modal-select-dining-option").click();
      localStorage.setItem(
        localStorageName("DINING_OPTION"),
        this.takeAwayOrDineIn
      );
      this.diningOption = String(value);
      EventBus.emit("DiningOptionChanged");
    },

    // KSK055: drop the cart items carrying an option restricted to the other
    // dining option, then list them with the reason.
    removeItemsInvalidForDining(value) {
      const orderInfo = JSON.parse(localStorage.getItem(this.cartName) || "[]") ?? [];
      const invalidIndexes = getCartItemIndexesInvalidForDiningOption(orderInfo, value);
      if (!invalidIndexes.length) return;

      this.removedDiningItems = invalidIndexes.map((index) => ({
        name: this.tName(orderInfo[index].item_name),
        quantity: orderInfo[index].quantity,
      }));
      this.removedDiningOption = Number(value);
      localStorage.setItem(
        this.cartName,
        JSON.stringify(orderInfo.filter((item, index) => !invalidIndexes.includes(index)))
      );
      // Item card quantities read the cart straight from localStorage.
      this.$forceUpdate();
      EventBus.emit("AddToCartSuccess");
      $(".btn-show-modal-dining-items-removed").click();
    },

    confirmStartOver() {
      this.closeAllModal();
      this.txtConfirm = this.$t("kiosk.order.confirmStartOver");
      this.kskConfirmPreset = "startOver";
      this.confirmType = 1;
      $(".btn-confirm-modal").click();
    },

    startOver() {
      localStorage.removeItem(this.cartName);
      localStorage.removeItem(localStorageName("DINING_OPTION"));

      if (this.memberInfo) {
        this.logout();
      }

      this.gotoPath("LandingPageKiosk");
    },

    gotoOrderDetail(
      categoryId,
      id,
      stock_balance,
      is_not_available,
      stock_enable_balance,
      item
    ) {
      // console.log(stock_balance, is_not_available, stock_enable_balance, item)
      // if(this.checkAvailableItem(item) && item.isHaveModifierOptionGroups > 0) {
      if (this.checkAvailableItem(item)) {
        this.categoryIdSelect = categoryId;
        this.itemIdSelect = id;

        // this.showLoader();
        let dataForm = {
          menuset_id: this.branch.menuset_id ?? 0,
          category_id: categoryId,
          item_id: id,
          branch_code: this.branchCode,
          take_away_or_dine_in: getDiningOption(),
          is_kiosk: 1
        };

        // KSK063: open the sheet right away with a placeholder instead of
        // waiting for the API (slow connections felt laggy). By-weight items
        // still wait: they open ModalWeighing first.
        const requestId = ++this.itemDetailRequestId;
        const openSheetNow = !item.is_by_weight;
        if (openSheetNow) {
          this.itemDetailLoading = true;
          this.closeAllModal();
          this.openItemSheet();
        }

        OrderService.getItemDetail(dataForm).then(
          (response) => {
            if (requestId !== this.itemDetailRequestId) return;
            this.itemDetailLoading = false;
            if (response.data.result.isSuccess) {
              const data = response.data.data;
              // By Weight flow: show ModalWeighing first, then ModalItemDetail after Next
              if (data && data.is_by_weight) {
                this.itemDetail = data;
                this.weighingItemDetail = data;
                this.reloadWeighingModal = Math.random(32).toString();
                this.closeAllModal();
                if (openSheetNow) this.hideItemSheet();
                $(".btn-show-weighing-modal").click();
              } else {
                this.itemDetail = data;
                this.reloadModal = Math.random(32).toString();
                if (!openSheetNow) {
                  this.closeAllModal();
                  $(".btn-show-item-detail-modal").click();
                }
              }
            } else {
              if (openSheetNow) this.hideItemSheet();
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.isLoadDone = true;
            // this.hideLoader();
          },
          (error) => {
            if (requestId !== this.itemDetailRequestId) return;
            this.itemDetailLoading = false;
            if (openSheetNow) this.hideItemSheet();
            this.snackbar = "danger";
            this.message = error;
            // this.hideLoader();
          }
        );
      }
    },

    // KSK063: Bootstrap ignores hide() while the open transition is still
    // running, so a hide requested then is replayed once the sheet is shown.
    openItemSheet() {
      const el = document.getElementById("modal_item_detail");
      this.itemSheetOpening = true;
      this.itemSheetHidePending = false;
      if (el) {
        el.addEventListener(
          "shown.bs.modal",
          () => {
            this.itemSheetOpening = false;
            if (this.itemSheetHidePending) {
              this.itemSheetHidePending = false;
              $(".btn-hide-item-detail-modal").click();
            }
          },
          { once: true }
        );
      }
      $(".btn-show-item-detail-modal").click();
    },

    hideItemSheet() {
      if (this.itemSheetOpening) {
        this.itemSheetHidePending = true;
      } else {
        $(".btn-hide-item-detail-modal").click();
      }
    },

    // KSK040: App.vue zooms <html> on kiosk routes. jQuery offset() reads
    // getBoundingClientRect (screen px) while scrollTop / css() take the
    // page's own px, so screen positions are divided by this factor.
    kioskZoom() {
      const body = document.body;
      return body.offsetWidth ? body.getBoundingClientRect().width / body.offsetWidth : 1;
    },

    selectCategory(category, index) {
      this.categorySelect = category;
      this.categoryIndexSelect = index;
      this.groupSelect = null;

      if (index > 1) {
        setTimeout(() => {
          const screenHeight = $(".category-list").height();
          $(".category-list").animate(
            {
              scrollTop:
                $("#category-tag-" + category.id).offset().top / this.kioskZoom() +
                $(".category-list").scrollTop() -
                screenHeight / 3,
            },
            300
          );
        }, 100);
      } else {
        $(".category-list").scrollLeft(0);
        setTimeout(() => {
          $(".category-list").animate(
            {
              scrollTop: 0,
            },
            300
          );
        }, 100);
      }

      $(".order-info .content").animate(
        {
          scrollTop: 0,
        },
        300
      );
    },

    selectGroup(group) {
      this.groupSelect = group;
      if (this.typeList == 2) {
        $(".group-list > .group-tag").removeClass("active");
        $("#group-tag-" + group.id).addClass("active");
        $(".content-custom").scrollTop(0, 0);
        $(".content-custom").animate(
          {
            scrollTop:
              $(".tag-name-group-" + group.id).offset().top / this.kioskZoom() - 80,
          },
          500
        );
      } else {
        $(".group-list > .group-tag").removeClass("active");
        $("#group-tag-" + group.id).addClass("active");
        $(".content-custom").scrollTop(0, 0);
        setTimeout(() => {
          $(".content-custom").animate(
            {
              scrollTop:
                $(".tag-name-group-" + group.id).offset().top / this.kioskZoom() -
                (110 - $(".order-header").height()),
            },
            500
          );
        }, 100);
      }
    },

    // KSK054: menu names come from the POS in the source language; translated
    // per the locale picked on Landing (originals while loading / on English).
    tName(source) {
      return translatedName(source);
    },

    // KSK123: every language too, so the header switch needs no wait even when
    // the menu opened without passing Landing (reload).
    syncMenuNames() {
      const names = collectItemNames(this.categories || []);
      loadMenuTranslations(names, this.$i18n.locale);
      prefetchMenuTranslations(names);
    },

    async getListCategory(type, isLoadingAnimation) {
      if (isLoadingAnimation) {
        this.showLoader();
      }
      let dataForm = {
        menuset_id: this.branch.menuset_id ?? 0,
        branch_code: this.branch.branch_code ?? "",
      };

      await OrderService.getListCategory(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.isLoadDone = true;
            this.categories = response.data.data.categories;
            this.syncMenuNames();
            this.showDiningOption = response.data.data.show_dining_option;
            this.dining_location = response.data.data.dining_location;

            if (
              this.showDiningOption &&
              localStorage.getItem(localStorageName("DINING_OPTION")) === null
            ) {
              $(".btn-show-modal-select-dining-option").click();
            } else {
              if (!this.showDiningOption) {
                localStorage.removeItem(localStorageName("DINING_OPTION"));
                this.diningOption = null;
                // Header read DINING_OPTION when it was created; drop its pill too.
                EventBus.emit("DiningOptionChanged");
              }
            }

            if (type == 1) {
              if (this.categories.length) {
                if (this.categoryIdSelect) {
                  this.categories.forEach((category, index) => {
                    if (this.categoryIdSelect == category.id) {
                      this.selectCategory(category, index, true);
                      return;
                    }
                  });
                } else {
                  this.categorySelect = this.categories[0];
                  this.categoryIndexSelect = 0;
                  this.groupSelect = null;

                  setTimeout(() => {
                    $(".tag-name-category-" + this.categorySelect.id).addClass(
                      "active"
                    );
                  }, 100);
                }
              }
            }
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.isLoadDone = true;
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
        }
      );
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    // Red toast raised by a child modal that refused an action (e.g. a by-weight
    // item below the minimum, or one that never went through the scale).
    showKioskError(message) {
      if (!message) {
        return;
      }

      this.snackbar = "danger";
      this.message = message;
      this.setTimeOutNotification();
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    checkAndReturnPopular(array) {
      if (array && array.length > 0) {
        if (array.includes("Popular")) {
          return "Popular";
        } else {
          return "";
        }
      }
      return "";
    },

    checkAndReturnSignature(array) {
      if (array && array.length > 0) {
        if (array.includes("Signature")) {
          return "Signature";
        } else {
          return "";
        }
      }
      return "";
    },

    clickLink(link) {
      if (link && link != "") {
        window.open(link);
      }
    },

    checkAvailableItem(item) {
      if (item.stock_enable_balance) {
        // countdown = true
        if (item.stock_balance > 0) {
          return true;
        } else {
          return false;
        }
      } else {
        // countdown = false
        if (item.is_not_available == 0) {
          return true;
        } else {
          return false;
        }
      }
    },

    getTotalQuantityById(id) {
      const data = JSON.parse(localStorage.getItem(this.cartName, []));
      let totalQuantity = 0;
      if (data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].id === id) {
            totalQuantity += data[i].quantity;
          }
        }
      }
      return totalQuantity;
    },

    async handleQuantityForMainItem(
      mainItem,
      type,
      category_id,
      categoryIndex,
      itemIndex
    ) {
      // 1 is - | 2 is +
      let orderInfo =
        JSON.parse(localStorage.getItem(this.cartName, null)) ?? [];
      const indexToAddQuantity = orderInfo.findIndex(
        (item) => item.id === mainItem.id
      );
      if (type == 1) {
        if (this.getTotalQuantityById(mainItem.id) === 1) {
          // If quantity is going to be decremented to 0, show confirm dialog
          if (
            confirm(
              this.$t("kiosk.order.confirmRemove", { name: this.tName(mainItem.item_name) })
            )
          ) {
            this.showLoader();
            this.categories[categoryIndex].items[itemIndex].quantity =
              orderInfo[indexToAddQuantity].quantity - 1;
            orderInfo[indexToAddQuantity].quantity =
              orderInfo[indexToAddQuantity].quantity - 1;
            if (orderInfo[indexToAddQuantity].quantity == 0) {
              orderInfo.splice(indexToAddQuantity, 1);
            }
            localStorage.removeItem(this.cartName);
            localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
            this.isLoadDone = true;
            this.hideLoader();
            EventBus.emit("AddToCartSuccess");
          }
        } else {
          if (orderInfo[indexToAddQuantity]) {
            if (orderInfo[indexToAddQuantity].quantity > 0) {
              this.showLoader();
              this.categories[categoryIndex].items[itemIndex].quantity =
                orderInfo[indexToAddQuantity].quantity - 1;
              orderInfo[indexToAddQuantity].quantity =
                orderInfo[indexToAddQuantity].quantity - 1;
              localStorage.removeItem(this.cartName);
              localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
              this.isLoadDone = true;
              this.hideLoader();
              EventBus.emit("ChangeItemQuantitySuccess");
            }
          }
        }
      } else if (type == 2) {
        if (orderInfo[indexToAddQuantity]) {
          this.addCartAnimation(mainItem.id, itemIndex, category_id);
          this.showLoader();
          this.categories[categoryIndex].items[itemIndex].quantity =
            orderInfo[indexToAddQuantity].quantity + 1;
          orderInfo[indexToAddQuantity].quantity =
            orderInfo[indexToAddQuantity].quantity + 1;
          localStorage.removeItem(this.cartName);
          localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
          this.isLoadDone = true;
          this.hideLoader();
          EventBus.emit("ChangeItemQuantitySuccess");
        } else {
          if (this.isLoadingGetItemDetail == false) {
            if (this.isOnline) {
              this.addCartAnimation(mainItem.id, itemIndex, category_id);
              this.isLoadingGetItemDetail = true;
              this.showLoaderWithoutAnimation();
              let dataForm = {
                menuset_id: this.branch.menuset_id ?? 0,
                category_id: category_id,
                item_id: mainItem.id,
                branch_code: this.branchCode,
                take_away_or_dine_in: getDiningOption(),
                is_kiosk: 1,
              };

              OrderService.getItemDetail(dataForm).then(
                (response) => {
                  if (response.data.result.isSuccess) {
                    this.categories[categoryIndex].items[
                      itemIndex
                    ].quantity = 1;
                    let orderInfo =
                      JSON.parse(localStorage.getItem(this.cartName, null)) ??
                      [];
                    let itemDetail = response.data.data;
                    itemDetail.price_default = parseFloat(
                      itemDetail.price_default
                    );
                    itemDetail.member_price = parseFloat(
                      itemDetail.member_price
                    );

                    orderInfo.push(itemDetail);
                    localStorage.setItem(
                      this.cartName,
                      JSON.stringify(orderInfo)
                    );
                    EventBus.emit("ChangeItemQuantitySuccess");
                  } else {
                    this.snackbar = "danger";
                    this.message = response.data.result.message;
                    this.setTimeOutNotification();
                  }
                  this.isLoadDone = true;
                  this.hideLoaderWithoutAnimation();
                  this.isLoadingGetItemDetail = false;
                },
                (error) => {
                  this.snackbar = "danger";
                  this.message = error;
                  this.hideLoaderWithoutAnimation();
                  this.isLoadingGetItemDetail = false;
                }
              );
            } else {
              alert(this.$t("kiosk.order.lostInternet"));
            }
          }
        }
      }
    },

    openBoxChangeQuantityForItemWithoutModifier(
      categoryIndex,
      itemIndex,
      item,
      category_id
    ) {
      for (const category of this.categories) {
        for (const item of category.items) {
          delete item.openingEditQuantity;
        }
      }
      this.categories[categoryIndex].items[
        itemIndex
      ].openingEditQuantity = true;
      if (item) {
        this.handleQuantityForMainItem(
          item,
          2,
          category_id,
          categoryIndex,
          itemIndex
        );
      }
    },

    async groupHandleQuantityForMainItem(
      mainItem,
      type,
      category_id,
      groupIndex,
      itemIndex,
      categoryIndex
    ) {
      // 1 is - | 2 is +
      let orderInfo =
        JSON.parse(localStorage.getItem(this.cartName, null)) ?? [];
      const indexToAddQuantity = orderInfo.findIndex(
        (item) => item.id === mainItem.id
      );
      if (type == 1) {
        if (this.getTotalQuantityById(mainItem.id) === 1) {
          // If quantity is going to be decremented to 0, show confirm dialog
          if (
            confirm(
              this.$t("kiosk.order.confirmRemove", { name: this.tName(mainItem.item_name) })
            )
          ) {
            this.showLoader();
            this.categories[categoryIndex].groups[groupIndex].items[
              itemIndex
            ].quantity = orderInfo[indexToAddQuantity].quantity - 1;
            orderInfo[indexToAddQuantity].quantity =
              orderInfo[indexToAddQuantity].quantity - 1;
            if (orderInfo[indexToAddQuantity].quantity == 0) {
              orderInfo.splice(indexToAddQuantity, 1);
            }
            localStorage.removeItem(this.cartName);
            localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
            this.isLoadDone = true;
            this.hideLoader();
            EventBus.emit("AddToCartSuccess");
          }
        } else {
          if (orderInfo[indexToAddQuantity]) {
            if (orderInfo[indexToAddQuantity].quantity > 0) {
              this.showLoader();
              this.categories[categoryIndex].groups[groupIndex].items[
                itemIndex
              ].quantity = orderInfo[indexToAddQuantity].quantity - 1;
              orderInfo[indexToAddQuantity].quantity =
                orderInfo[indexToAddQuantity].quantity - 1;
              localStorage.removeItem(this.cartName);
              localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
              this.isLoadDone = true;
              this.hideLoader();
              EventBus.emit("ChangeItemQuantitySuccess");
            }
          }
        }
      } else if (type == 2) {
        if (orderInfo[indexToAddQuantity]) {
          this.addCartAnimation(
            mainItem.id,
            itemIndex,
            this.categories[categoryIndex].id,
            this.categories[categoryIndex].groups[groupIndex].id
          );
          this.showLoader();
          this.categories[categoryIndex].groups[groupIndex].items[
            itemIndex
          ].quantity = orderInfo[indexToAddQuantity].quantity + 1;
          orderInfo[indexToAddQuantity].quantity =
            orderInfo[indexToAddQuantity].quantity + 1;
          localStorage.removeItem(this.cartName);
          localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
          this.isLoadDone = true;
          this.hideLoader();
          EventBus.emit("ChangeItemQuantitySuccess");
        } else {
          if (this.isLoadingGetItemDetail == false) {
            if (this.isOnline) {
              this.addCartAnimation(
                mainItem.id,
                itemIndex,
                this.categories[categoryIndex].id,
                this.categories[categoryIndex].groups[groupIndex].id
              );
              this.isLoadingGetItemDetail = true;
              this.showLoaderWithoutAnimation();
              let dataForm = {
                menuset_id: this.branch.menuset_id ?? 0,
                category_id: category_id,
                item_id: mainItem.id,
                branch_code: this.branchCode,
                take_away_or_dine_in: getDiningOption(),
                is_kiosk: 1,
              };

              OrderService.getItemDetail(dataForm).then(
                (response) => {
                  if (response.data.result.isSuccess) {
                    this.categories[categoryIndex].groups[groupIndex].items[
                      itemIndex
                    ].quantity = 1;
                    let orderInfo =
                      JSON.parse(localStorage.getItem(this.cartName, null)) ??
                      [];
                    let itemDetail = response.data.data;
                    itemDetail.price_default = parseFloat(
                      itemDetail.price_default
                    );
                    itemDetail.member_price = parseFloat(
                      itemDetail.member_price
                    );

                    orderInfo.push(itemDetail);
                    localStorage.setItem(
                      this.cartName,
                      JSON.stringify(orderInfo)
                    );
                    EventBus.emit("ChangeItemQuantitySuccess");
                  } else {
                    this.snackbar = "danger";
                    this.message = response.data.result.message;
                    this.setTimeOutNotification();
                  }
                  this.isLoadDone = true;
                  this.hideLoaderWithoutAnimation();
                  this.isLoadingGetItemDetail = false;
                },
                (error) => {
                  this.snackbar = "danger";
                  this.message = error;
                  this.hideLoaderWithoutAnimation();
                  this.isLoadingGetItemDetail = false;
                }
              );
            } else {
              alert(this.$t("kiosk.order.lostInternet"));
            }
          }
        }
      }
    },

    groupOpenBoxChangeQuantityForItemWithoutModifier(
      groupIndex,
      itemIndex,
      categoryIndex,
      item,
      group_id
    ) {
      for (const category of this.categories) {
        for (const group of category.groups) {
          for (const item of group.items) {
            delete item.openingEditQuantity;
          }
        }
      }
      this.categories[categoryIndex].groups[groupIndex].items[
        itemIndex
      ].openingEditQuantity = true;
      if (item) {
        this.groupHandleQuantityForMainItem(
          item,
          2,
          group_id,
          groupIndex,
          itemIndex,
          categoryIndex
        );
      }
    },

    async subGroupHandleQuantityForMainItem(
      mainItem,
      type,
      category_id,
      groupIndex,
      itemIndex,
      categoryIndex,
      subGroupIndex
    ) {
      // 1 is - | 2 is +
      let orderInfo =
        JSON.parse(localStorage.getItem(this.cartName, null)) ?? [];
      const indexToAddQuantity = orderInfo.findIndex(
        (item) => item.id === mainItem.id
      );
      if (type == 1) {
        if (this.getTotalQuantityById(mainItem.id) === 1) {
          // If quantity is going to be decremented to 0, show confirm dialog
          if (
            confirm(
              this.$t("kiosk.order.confirmRemove", { name: this.tName(mainItem.item_name) })
            )
          ) {
            this.showLoader();
            this.categories[categoryIndex].groups[groupIndex].sub_groups[
              subGroupIndex
            ].sub_group_items[itemIndex].quantity =
              orderInfo[indexToAddQuantity].quantity - 1;
            orderInfo[indexToAddQuantity].quantity =
              orderInfo[indexToAddQuantity].quantity - 1;
            if (orderInfo[indexToAddQuantity].quantity == 0) {
              orderInfo.splice(indexToAddQuantity, 1);
            }
            localStorage.removeItem(this.cartName);
            localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
            this.isLoadDone = true;
            this.hideLoader();
            EventBus.emit("AddToCartSuccess");
          }
        } else {
          if (orderInfo[indexToAddQuantity]) {
            if (orderInfo[indexToAddQuantity].quantity > 0) {
              this.showLoader();
              this.categories[categoryIndex].groups[groupIndex].sub_groups[
                subGroupIndex
              ].sub_group_items[itemIndex].quantity =
                orderInfo[indexToAddQuantity].quantity - 1;
              orderInfo[indexToAddQuantity].quantity =
                orderInfo[indexToAddQuantity].quantity - 1;
              localStorage.removeItem(this.cartName);
              localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
              this.isLoadDone = true;
              this.hideLoader();
              EventBus.emit("ChangeItemQuantitySuccess");
            }
          }
        }
      } else if (type == 2) {
        if (orderInfo[indexToAddQuantity]) {
          this.addCartAnimation(
            mainItem.id,
            itemIndex,
            this.categories[categoryIndex].id,
            this.categories[categoryIndex].groups[groupIndex].id,
            this.categories[categoryIndex].groups[groupIndex].sub_groups[
              subGroupIndex
            ].id
          );
          this.showLoader();
          this.categories[categoryIndex].groups[groupIndex].sub_groups[
            subGroupIndex
          ].sub_group_items[itemIndex].quantity =
            orderInfo[indexToAddQuantity].quantity + 1;
          orderInfo[indexToAddQuantity].quantity =
            orderInfo[indexToAddQuantity].quantity + 1;
          localStorage.removeItem(this.cartName);
          localStorage.setItem(this.cartName, JSON.stringify(orderInfo));
          this.isLoadDone = true;
          this.hideLoader();
          EventBus.emit("ChangeItemQuantitySuccess");
        } else {
          if (this.isLoadingGetItemDetail == false) {
            if (this.isOnline) {
              this.addCartAnimation(
                mainItem.id,
                itemIndex,
                this.categories[categoryIndex].id,
                this.categories[categoryIndex].groups[groupIndex].id,
                this.categories[categoryIndex].groups[groupIndex].sub_groups[
                  subGroupIndex
                ].id
              );
              this.isLoadingGetItemDetail = true;
              this.showLoaderWithoutAnimation();
              let dataForm = {
                menuset_id: this.branch.menuset_id ?? 0,
                category_id: category_id,
                item_id: mainItem.id,
                branch_code: this.branchCode,
                take_away_or_dine_in: getDiningOption(),
                is_kiosk: 1,
              };

              OrderService.getItemDetail(dataForm).then(
                (response) => {
                  if (response.data.result.isSuccess) {
                    this.categories[categoryIndex].groups[
                      groupIndex
                    ].sub_groups[subGroupIndex].sub_group_items[
                      itemIndex
                    ].quantity = 1;
                    let orderInfo =
                      JSON.parse(localStorage.getItem(this.cartName, null)) ??
                      [];
                    let itemDetail = response.data.data;
                    itemDetail.price_default = parseFloat(
                      itemDetail.price_default
                    );
                    itemDetail.member_price = parseFloat(
                      itemDetail.member_price
                    );

                    orderInfo.push(itemDetail);
                    localStorage.setItem(
                      this.cartName,
                      JSON.stringify(orderInfo)
                    );
                    EventBus.emit("ChangeItemQuantitySuccess");
                  } else {
                    this.snackbar = "danger";
                    this.message = response.data.result.message;
                    this.setTimeOutNotification();
                  }
                  this.isLoadDone = true;
                  this.hideLoaderWithoutAnimation();
                  this.isLoadingGetItemDetail = false;
                },
                (error) => {
                  this.snackbar = "danger";
                  this.message = error;
                  this.hideLoaderWithoutAnimation();
                  this.isLoadingGetItemDetail = false;
                }
              );
            } else {
              alert(this.$t("kiosk.order.lostInternet"));
            }
          }
        }
      }
    },

    subGroupOpenBoxChangeQuantityForItemWithoutModifier(
      groupIndex,
      itemIndex,
      categoryIndex,
      subGroupIndex,
      item,
      subGroupId
    ) {
      for (const category of this.categories) {
        for (const group of category.groups) {
          for (const subGroup of group.sub_groups) {
            for (const item of subGroup.sub_group_items) {
              delete item.openingEditQuantity;
            }
          }
        }
      }
      this.categories[categoryIndex].groups[groupIndex].sub_groups[
        subGroupIndex
      ].sub_group_items[itemIndex].openingEditQuantity = true;
      if (item) {
        this.subGroupHandleQuantityForMainItem(
          item,
          2,
          subGroupId,
          groupIndex,
          itemIndex,
          categoryIndex,
          subGroupIndex
        );
      }
    },

    addCartAnimation(
      itemId,
      itemIndex,
      categoryId,
      groupId = 0,
      subGroupId = 0
    ) {
      let prefixClass = categoryId;

      if (groupId) {
        prefixClass += "-" + groupId;
      }

      if (subGroupId) {
        prefixClass += "-" + subGroupId;
      }

      prefixClass += "-" + itemId;

      let item = $(".item-img-" + prefixClass);
      let img = item.find("img").attr("src");
      const zoom = this.kioskZoom();
      let itemX = item.offset().left / zoom;
      let itemY = item.offset().top / zoom;
      let itemWidth = item.width();

      // KSK064: one clone per tap — sharing #show let the previous tap's
      // delayed fade-out hide the next one when "+" was tapped quickly.
      const fly = $("#show").clone().removeAttr("id");
      fly
        .css({
          left: itemX,
          top: itemY,
          width: itemWidth,
          height: itemWidth,
          opacity: 1,
          zIndex: 99999,
        })
        .find("img")
        .attr("src", img);
      fly.insertAfter("#show");

      TweenMax.to(fly[0], 0.25, {
        top: $(".footer").offset().top / zoom,
        left: $(window).width() / zoom / 2 - 40,
        width: 20,
      });
      TweenMax.to(fly[0], 0.15, {
        css: {
          opacity: 0,
        },
        delay: 0.15,
        onComplete: () => fly.remove(),
      });
    },

    gotoPath(name) {
      this.$router.push({
        name: name,
        params: {
          merchant_code: this.merchantCode,
          branch_code: this.branchCode,
        },
      });
    },

    showLoaderWithoutAnimation() {
      this.loaderActiveWithoutAnimation = true;
    },

    hideLoaderWithoutAnimation() {
      this.loaderActiveWithoutAnimation = false;
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    confirmLogout() {
      this.txtConfirm = this.$t("kiosk.common.confirmLogout");
      this.kskConfirmPreset = "logout";
      this.confirmType = 2;
      $(".btn-confirm-modal").click();
    },

    logout() {
      memberService.logout(this.merchantCode);
      localStorage.removeItem(localStorageName("PAYMENT_METHOD"));
      localStorage.removeItem(localStorageName("SELECTED_REWARD"));
      this.memberInfo = null;
      this.isLogined = false;

      EventBus.emit("LogoutSuccess");

      this.logoutDone();
    },

    processYes() {
      this.closeAllModal();

      if (this.confirmType == 1) {
        // start over
        this.startOver();
      } else if (this.confirmType == 2) {
        // logout
        this.logout();
      }
    },
  },
};
</script>

<style scoped>
.content-custom {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: hidden;
  /* KSK105: an unscoped `.content-custom { background: white }` elsewhere
     paints this; keep white by default, take the merchant tint when set.
     KSK117: Minty's "Menu listing" background wins over both. */
  background: var(--ksk-c-bg_menu-accent, var(--ksk-tint-bg, #ffffff));
}

/* KSK002 layout shell: fixed header + fixed bottom bar; only this area scrolls
   (the category rail and item list scroll inside it).
   Pinned to the viewport between the fixed header and the fixed bottom bar: a
   %-height broke when the page box is taller than the visible screen (browser
   chrome / 100vh), leaving the last item row hidden under the bottom bar. */
.order-info {
  position: fixed;
  /* KSK070: no search bar under the header (kiosk has no menu search);
     KSK062's "Powered by" strip sits under the bottom bar. */
  top: var(--ksk-header-height);
  bottom: calc(var(--ksk-bottom-bar-height) + var(--ksk-powered-height));
  left: 0;
  right: 0;
  width: 100%;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  gap: var(--ksk-gutter);
  padding: 0 var(--ksk-page-padding) 0 0;
}

/* KSK007 category rail: 220px, 180px tiles. */
.category-list {
  flex: 0 0 220px;
  width: 220px;
  overflow-y: auto;
  overflow-x: hidden;
  padding: var(--ksk-space-2) 0;
  /* KSK117: Minty's "Menu category" background. */
  background: var(--ksk-c-bg_category-accent, var(--ksk-surface));
  box-shadow: var(--ksk-shadow-card);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--ksk-space-1);
}

.category-tag {
  flex-shrink: 0;
  width: 180px;
  height: 180px;
  padding: 4px 12px;
  justify-content: center;
  border-radius: var(--ksk-radius-card);
  text-align: center;
  cursor: pointer;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  font-family: var(--ksk-font);
  color: var(--ksk-text);
  -webkit-tap-highlight-color: transparent;
}

/* KSK063: category_tab colour slot (accent = bar + tint, font = name,
   outline = ring); theme values otherwise. */
.category-tag.active {
  background: color-mix(in srgb, var(--ksk-slot-accent, var(--ksk-primary)) 12%, #ffffff);
  box-shadow: inset 0 0 0 2px var(--ksk-slot-outline, transparent);
}
.category-tag.active::before {
  content: "";
  position: absolute;
  left: 0;
  top: 16px;
  bottom: 16px;
  width: 6px;
  border-radius: 0 6px 6px 0;
  background: var(--ksk-slot-accent, var(--ksk-primary));
}

.wrap-category {
  position: relative;
  width: 120px;
  height: 120px;
}

.category-tag .c-img {
  width: 120px;
  height: 120px;
  border-radius: 16px;
  object-fit: cover;
  background: var(--ksk-surface-muted);
}

.category-tag .c-name {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 2;
  width: 100%;
  min-height: 48px;
  font-size: 20px;
  line-height: 24px;
  font-weight: 500;
  word-break: break-word;
}

.category-tag.active .c-name {
  color: var(--ksk-slot-font, var(--ksk-primary));
  font-weight: 700;
}

/* KSK008 item area: category title, group headers, 2-column grid. */
.ksk-category-head {
  display: flex;
  align-items: center;
  gap: var(--ksk-space-2);
  margin-bottom: var(--ksk-space-3);
  font-family: var(--ksk-font);
}
.ksk-category-head__title {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin: 0;
  font-family: var(--ksk-font);
  font-size: var(--ksk-title-size);
  line-height: var(--ksk-title-lh);
  font-weight: 700;
  color: var(--ksk-text);
}
.ksk-category-head__count {
  font-size: var(--ksk-caption-size);
  line-height: var(--ksk-caption-lh);
  color: var(--ksk-text-secondary);
  white-space: nowrap;
}
.item-list .tag-name-group,
.item-list .tag-name-sub-group {
  margin: var(--ksk-space-4) 0 var(--ksk-space-2);
  font-family: var(--ksk-font);
  font-size: 24px;
  line-height: 30px;
  font-weight: 700;
  color: var(--ksk-text);
}
.item-list .tag-name-sub-group {
  color: var(--ksk-text-secondary);
}
.ksk-item-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--ksk-gutter);
  padding-bottom: var(--ksk-space-1);
}

.content {
  flex: 1;
  min-width: 0;
  overflow-y: auto;
  height: 100%;
  padding-top: var(--ksk-space-3);
}

.group-and-type-list {
  margin: 0 24px;
}

.category-detail.list,
.group-list.list,
.group-and-type-list.list {
  margin-left: 20px !important;
  padding-left: 0 !important;
}

.category-description {
  font-weight: normal;
  font-size: 11px;
  color: gray;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 1;
}

.group-list .group-tag {
  font-size: 13px;
  font-weight: bold;
  padding: 5px 25px;
  background: #f1f1f1;
  border-radius: 20px;
  white-space: pre;
  cursor: pointer;
}

.group-list .group-tag.active {
  background: var(--color);
}

.group-list .group-tag:not(:last-child) {
  margin-right: 15px;
}

.category-list::-webkit-scrollbar,
.group-list::-webkit-scrollbar,
.content::-webkit-scrollbar {
  display: none;
}

.item-list .tag-name {
  font-size: 18px;
  font-weight: bold;
}


input[type="search"] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
  background-color: #ffffff !important;
  border-radius: 50px;
  text-align: left !important;
}

input[type="search"]::placeholder {
  color: #bbb;
  text-align: left;
  font-weight: normal;
  font-size: 13px;
}

input[type="search"]:focus {
  outline: none;
  border: none;
}

input.nosubmit {
  width: 100%;
  height: 32px;
  padding: 5px 4px 5px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}

.banner {
  position: relative;
}

.item-list > div:first-child {
  padding: 5px 0;
}

.material-icons-round.active {
  color: var(--color);
}

.wrap-category > .custom-star {
  position: absolute;
  right: 6px;
  top: 6px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--ksk-warning);
  color: var(--ksk-on-status);
  font-size: 18px;
  box-shadow: var(--ksk-shadow-card);
}
.container-custom {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--ksk-background);
}
.addOverFlow {
  overflow-y: auto;
}
.removeOverFlow {
  overflow-y: auto;
}
.selectedItem {
  /* border-left: 2px solid var(--color); */
  /* padding-left: 5px; */
}
/* webkit solution */
::-webkit-input-placeholder {
  text-align: left !important;
}
/* mozilla solution */
input:-moz-placeholder {
  text-align: left !important;
}
</style>
